import { round } from 'lodash';
import { spacing, spacingSizes } from '../../../theme';
import { cssPxToPdfPt } from '../../Pdf/jsonToPDF/block-note-pdf-block-utils';

const A4_PAGE_WIDTH_PT = 595;
const PARTIAL_WIDTH_RATIO = 0.9;
const FULL_WIDTH_PREVIEW_RATIO_THRESHOLD = 0.995;
const COMMENTARY_EDITOR_FULL_PREVIEW_WIDTH_CSS_PX = 766;

const pageHorizontalPaddingCssPx = spacingSizes.lg * spacing;
const commentaryBodyHorizontalPaddingCssPx = spacingSizes.lg * spacing;
const commentaryEditorContainerHorizontalPaddingCssPx =
  2 * spacingSizes.sm * spacing;

export const COMMENTARY_MAX_IMAGE_WIDTH_PT = round(
  A4_PAGE_WIDTH_PT -
    2 * cssPxToPdfPt(pageHorizontalPaddingCssPx) -
    2 * cssPxToPdfPt(commentaryBodyHorizontalPaddingCssPx),
  1,
);

export const commentaryMaxImagePreviewWidthCssPx = round(
  (COMMENTARY_MAX_IMAGE_WIDTH_PT * 96) / 72,
  1,
);

export const commentaryEditorMaxPreviewWidthCssPx = round(
  COMMENTARY_EDITOR_FULL_PREVIEW_WIDTH_CSS_PX -
    commentaryEditorContainerHorizontalPaddingCssPx,
);

const commentaryEditorPartialResizeReferenceWidthCssPx = round(
  COMMENTARY_EDITOR_FULL_PREVIEW_WIDTH_CSS_PX / PARTIAL_WIDTH_RATIO,
);

export function previewWidthCssPxToPdfPt(previewWidthCssPx: number) {
  if (previewWidthCssPx <= 0) {
    return 0;
  }

  if (
    previewWidthCssPx >=
    COMMENTARY_EDITOR_FULL_PREVIEW_WIDTH_CSS_PX *
      FULL_WIDTH_PREVIEW_RATIO_THRESHOLD
  ) {
    return COMMENTARY_MAX_IMAGE_WIDTH_PT;
  }

  const widthPt = round(
    (previewWidthCssPx / commentaryEditorPartialResizeReferenceWidthCssPx) *
      COMMENTARY_MAX_IMAGE_WIDTH_PT,
    1,
  );

  if (widthPt >= COMMENTARY_MAX_IMAGE_WIDTH_PT) {
    return COMMENTARY_MAX_IMAGE_WIDTH_PT;
  }

  return widthPt;
}

export function scaleImagePreviewWidthCssPx(
  widthCssPx: number,
  heightCssPx: number,
  maxWidthCssPx = commentaryEditorMaxPreviewWidthCssPx,
) {
  const width = round(widthCssPx);
  const height = round(heightCssPx);
  if (width <= 0 || height <= 0) {
    return 0;
  }
  if (width > maxWidthCssPx) {
    return maxWidthCssPx;
  }
  return width;
}
